import React from 'react';
import { CardComponent } from '../CardComponent';

export function NewClient(props) {
  const { bankAbbr, bankName, isLoading, setBankAbbr, setBankName, setNewClientModal, addNewClient } = props;

  return (
    <CardComponent
      title={'Add New Client'}
      titleStyles={{ display: 'inline-block', fontSize: '2.6rem', fontWeight: 400, marginLeft: '30px', marginTop: '20px' }}
      styles={{ position: 'fixed', top: '20%', left: '20%', zIndex: 1050, background: 'white', height: '317px', width: '600px', border: 'solid grey', borderRadius: '10px' }}
      isLoading={isLoading}
      disableCardBackgroundColor
    >
      <div style={{ margin: '20px' }}>
        <div style={{ marginTop: '10px', marginLeft: '10px', marginRight: '10px', borderRadius: '15px' }}>
          <span>
            Client Name
          </span>
          <input style={{ height: '14px' }}
            type="text"
            placeholder=""
            value={bankName}
            onChange={(e) => setBankName(e.target.value)}
          />
        </div>
        <div style={{ marginTop: '10px', marginLeft: '10px', marginRight: '10px' }}>
          <span>
            Abbreviaton
          </span>
          <input style={{ height: '14px' }}
            type="text"
            placeholder=""
            value={bankAbbr}
            onChange={(e) => setBankAbbr(e.target.value)}
          />
        </div>
        <div
          // className="modal-footer" 
          style={{ marginTop: '10px', marginBottom: '20px' }}
        >
          <a
            onClick={() => { addNewClient() }}
            className="btn btn-action"
            style={{ marginLeft: '10px', marginRight: '8px', marginBottom: '20px' }}
          >
            Save
          </a>
          <a className="btn btn-white"
            onClick={() => { setNewClientModal(false) }}
            style={{ cursor: 'pointer', width: '100px', marginBottom: '20px' }}
          >
            CLOSE
          </a>
        </div>
      </div>
    </CardComponent>
  );
}



